module.exports = __webpack_public_path__ + "img/table-addca-icon-white.1346f52c.svg";